export interface Dom {
    $spinner: HTMLDivElement;
    $loadingSpinner: Element | null;

    $sectionShipping: HTMLDivElement | null;
    $sectionTax: HTMLDivElement | null;
    $sectionPayment: HTMLDivElement | null;
    $sectionAdditionalDetails: HTMLDivElement | null;
    $orderSummaryColumn: HTMLDivElement | null;

    $orderSummary: Element | null;
    $savingsAmt: HTMLSpanElement;
    $availableDiscountAmt: HTMLSpanElement;
    $availableDiscountLine: HTMLElement;
    $shippingAmt: HTMLSpanElement;
    $taxAmt: HTMLSpanElement;
    $subtotalAmt: HTMLSpanElement;
    $totalAmt: HTMLSpanElement;
    $cartTaxRateParents: NodeListOf<Element>;
    $cartTaxRateEl: NodeListOf<Element>;
    $savingsLine: HTMLElement;
    $prepaymentAmt: HTMLSpanElement;
    $prepaymentLine: HTMLElement;
    $prepaymentDeposits: HTMLElement;

    $promoName: HTMLSpanElement;
    $promoEl: HTMLElement;
    $collapseLink: HTMLAnchorElement;
    $promoInput: HTMLInputElement;
    $promoPreview: HTMLElement;
    $promoApplyBtn: HTMLButtonElement;

    $cartItemPreview: HTMLDivElement;

    $shippingPreview: HTMLDivElement;
    $shippingPreviewAddress: HTMLElement;
    $shippingPreviewPhone: HTMLElement;
    $shippingPreviewEmail: HTMLElement;
    $internationalShippingWarning: HTMLDivElement;
    $intlDutiesNotice: HTMLDivElement;
    $shippingBody: HTMLDivElement | null;
    $shippingBodyToggle: HTMLAnchorElement | null;
    $shippingOptionsParent: HTMLFieldSetElement | null;
    $shippingButtonsParent: HTMLDivElement | null;

    $taxPreview: HTMLDivElement;
    $taxPreviewTemplate: HTMLTemplateElement;
    $taxStateWarning: HTMLDivElement;
    $taxBody: HTMLDivElement | null;
    $taxBodyToggle: HTMLAnchorElement | null;
    $taxToggleYes: HTMLInputElement;
    $taxToggleNo: HTMLInputElement;
    $taxDetailsParent: HTMLFieldSetElement | null;
    $taxConfirmNone: HTMLButtonElement;

    $paymentBodyForm: HTMLFormElement | null;
    $paymentBodyFieldSet: HTMLFieldSetElement | null | undefined;
    $paymentBody: HTMLDivElement | null | undefined;
    $paymentBodyToggle: HTMLAnchorElement | null;
    $paymentPreview: HTMLDivElement;
    $paymentPreviewTemplate: HTMLTemplateElement;
    $paymentPreviewItemCC: HTMLTemplateElement;
    $paymentPreviewItemBank: HTMLTemplateElement;
    $paymentPreviewItemOther: HTMLTemplateElement;

    $additionalBody: HTMLDivElement | null | undefined;
    $additionalBodyToggle: HTMLAnchorElement | null | undefined;
    $additionalPreview: HTMLDivElement | null | undefined;
    $additionalDetailsForm: HTMLFormElement;
    $eventDateYes: HTMLInputElement;
    $eventDateNo: HTMLInputElement;
    $eventDate: HTMLInputElement;
    $promoApproval: HTMLInputElement;
    $smsApproval: HTMLInputElement;
    $designApproval: HTMLInputElement;

    $authorizePaymentBtn: HTMLButtonElement;
    $authorizePaymentText: HTMLElement;
    $authorizePaymentTextPlaceOrder: HTMLElement;
    $authorizePaymentTextPayPal: HTMLElement;

    $gsaSmartPayWarning: HTMLDivElement;
    $gsaSmartPayTaxAmount: HTMLElement;
    $gsaSmartPayAddExemption: HTMLAnchorElement;
}

export function QueryDom(): Dom {
    const $spinner = document.querySelector('#checkout-spinner') as HTMLDivElement;
    const $loadingSpinner = document.querySelector('#loading-spinner');

    const $sectionShipping = document.querySelector<HTMLDivElement>('#section-shipping');
    const $sectionTax = document.querySelector<HTMLDivElement>('#section-tax');
    const $sectionPayment = document.querySelector<HTMLDivElement>('#section-payment');
    const $sectionAdditionalDetails = document.querySelector<HTMLDivElement>('#section-additional');
    const $orderSummaryColumn = document.querySelector<HTMLDivElement>('#order-summary-column');

    const $orderSummary = document.querySelector('#order-summary');

    const $savingsAmt = $orderSummary?.querySelector('#savings-amount') as HTMLSpanElement;
    const $availableDiscountAmt = $orderSummary?.querySelector('#available-discount-amount') as HTMLSpanElement;
    const $availableDiscountLine = $availableDiscountAmt.closest('.pricing-line') as HTMLElement;
    const $shippingAmt = $orderSummary?.querySelector('#shipping-amount') as HTMLSpanElement;
    const $taxAmt = $orderSummary?.querySelector('#tax-amount') as HTMLSpanElement;
    const $subtotalAmt = $orderSummary?.querySelector('#subtotal-amount') as HTMLSpanElement;
    const $totalAmt = $orderSummary?.querySelector('#total-amount') as HTMLSpanElement;
    const $cartTaxRateParents = document.querySelectorAll('.cart-tax-rate-parent');
    const $cartTaxRateEl = document.querySelectorAll('.cart-tax-rate');
    const $savingsLine = $savingsAmt.closest('.pricing-line') as HTMLElement;

    const $prepaymentAmt = $orderSummary?.querySelector('#prepayment-amount') as HTMLSpanElement;
    const $prepaymentLine = $prepaymentAmt.closest('.pricing-line') as HTMLElement;
    const $prepaymentDeposits = $orderSummary?.querySelector('#prepayment-deposits') as HTMLElement;

    const $promoName = $orderSummary?.querySelector('#promo-code-name') as HTMLSpanElement;
    const $promoEl = $orderSummary?.querySelector('.promo') as HTMLElement;
    const $collapseLink = $promoEl.querySelector<HTMLAnchorElement>('a .link-text') as HTMLAnchorElement;
    const $promoInput = $promoEl.querySelector('#promo') as HTMLInputElement;
    const $promoPreview = $promoEl.querySelector<HTMLElement>('.promo-preview') as HTMLElement;
    const $promoApplyBtn = $promoEl.querySelector<HTMLButtonElement>('.btn') as HTMLButtonElement;

    const $cartItemPreview = document.querySelector('#your-cart-items') as HTMLDivElement;

    const $shippingPreview = $sectionShipping?.querySelector('#shipping-preview') as HTMLDivElement;
    const $shippingPreviewAddress = $shippingPreview.querySelector('#shipping-preview-address') as HTMLElement;
    const $shippingPreviewPhone = $shippingPreview.querySelector('#shipping-preview-phone') as HTMLElement;
    const $shippingPreviewEmail = $shippingPreview.querySelector('#shipping-preview-email') as HTMLElement;
    const $internationalShippingWarning = $sectionShipping?.querySelector<HTMLDivElement>('#intl-shipping-warning') as HTMLDivElement;
    const $intlDutiesNotice = document.querySelector('#intl-duties-notice') as HTMLDivElement;

    const $shippingBody = $sectionShipping?.querySelector<HTMLDivElement>('.collapse') ?? null;
    const $shippingBodyToggle = $sectionShipping?.querySelector<HTMLAnchorElement>('#shipping-body-toggle') ?? null;
    const $shippingOptionsParent = $sectionShipping?.querySelector<HTMLFieldSetElement>('#shipping-options-parent') ?? null;
    const $shippingButtonsParent = $sectionShipping?.querySelector<HTMLDivElement>('#shipping-buttons-parent') ?? null;

    const $taxPreview = $sectionTax?.querySelector('#tax-preview') as HTMLDivElement;
    const $taxPreviewTemplate = document.querySelector('#tax-preview-template') as HTMLTemplateElement;
    const $taxStateWarning = $sectionTax?.querySelector<HTMLDivElement>('#tax-state-warning') as HTMLDivElement;

    const $taxBody = $sectionTax?.querySelector<HTMLDivElement>('.collapse') ?? null;
    const $taxBodyToggle = $sectionTax?.querySelector<HTMLAnchorElement>('#tax-body-toggle') ?? null;
    const $taxToggleYes = $taxBody?.querySelector<HTMLInputElement>('#tax-exemption-yes') as HTMLInputElement;
    const $taxToggleNo = $taxBody?.querySelector<HTMLInputElement>('#tax-exemption-no') as HTMLInputElement;
    const $taxDetailsParent = $sectionTax?.querySelector<HTMLFieldSetElement>('#tax-exemption-details-parent') ?? null;
    const $taxConfirmNone = $taxBody?.querySelector<HTMLButtonElement>('#no-tax-exemption-confirm') as HTMLButtonElement;

    const $paymentBodyForm = $sectionPayment?.querySelector<HTMLFormElement>('#payment-body-form') ?? null;
    const $paymentBodyFieldSet = $paymentBodyForm?.querySelector<HTMLFieldSetElement>('#payment-body-fieldset');
    const $paymentBody = $paymentBodyForm?.querySelector<HTMLDivElement>('.collapse');
    const $paymentBodyToggle = $sectionPayment?.querySelector<HTMLAnchorElement>('#payment-body-toggle') ?? null;
    const $paymentPreview = $sectionPayment?.querySelector<HTMLDivElement>('#payment-preview') as HTMLDivElement;
    const $paymentPreviewTemplate = document.querySelector<HTMLTemplateElement>('#payment-preview-template') as HTMLTemplateElement;
    const $paymentPreviewItemCC = document.querySelector<HTMLTemplateElement>('#payment-preview-item-cc') as HTMLTemplateElement;
    const $paymentPreviewItemBank = document.querySelector<HTMLTemplateElement>('#payment-preview-item-bank') as HTMLTemplateElement;
    const $paymentPreviewItemOther = document.querySelector<HTMLTemplateElement>('#payment-preview-item-other') as HTMLTemplateElement;

    const $additionalBody = $sectionAdditionalDetails?.querySelector<HTMLDivElement>('.collapse');
    const $additionalBodyToggle = $sectionAdditionalDetails?.querySelector<HTMLAnchorElement>('#additional-body-toggle');
    const $additionalPreview = $sectionAdditionalDetails?.querySelector<HTMLDivElement>('#additional-preview');
    const $additionalDetailsForm = document.querySelector<HTMLFormElement>('#additional-details') as HTMLFormElement;
    const $eventDateYes = $additionalBody?.querySelector<HTMLInputElement>('#event-date-yes') as HTMLInputElement;
    const $eventDateNo = $additionalBody?.querySelector<HTMLInputElement>('#event-date-no') as HTMLInputElement;
    const $eventDate = $additionalBody?.querySelector<HTMLInputElement>('#event-date') as HTMLInputElement;
    const $promoApproval = $additionalBody?.querySelector<HTMLInputElement>('#promo-approval') as HTMLInputElement;
    const $smsApproval = $additionalBody?.querySelector<HTMLInputElement>('#sms-approval') as HTMLInputElement;
    const $designApproval = $additionalBody?.querySelector<HTMLInputElement>('#design-approval') as HTMLInputElement;

    const $gsaSmartPayWarning = $orderSummary?.querySelector('#gsa-smartpay-warning') as HTMLDivElement;
    const $gsaSmartPayTaxAmount = $orderSummary?.querySelector('#gsa-smartpay-tax-amount') as HTMLElement;
    const $gsaSmartPayAddExemption = $orderSummary?.querySelector('#gsa-smartpay-add-exemption') as HTMLAnchorElement;

    const $authorizePaymentBtn = document.querySelector('#authorize-payment') as HTMLButtonElement;
    const $authorizePaymentText = document.querySelector('#authorize-payment-text') as HTMLElement;
    const $authorizePaymentTextPlaceOrder = document.querySelector('#authorize-payment-text-place-order') as HTMLElement;
    const $authorizePaymentTextPayPal = document.querySelector('#authorize-payment-text-paypal') as HTMLElement;

    return {
        $spinner,
        $loadingSpinner,
        $sectionShipping,
        $sectionTax,
        $sectionPayment,
        $sectionAdditionalDetails,
        $orderSummaryColumn,
        $orderSummary,
        $savingsAmt,
        $availableDiscountAmt,
        $availableDiscountLine,
        $shippingAmt,
        $taxAmt,
        $subtotalAmt,
        $totalAmt,
        $cartTaxRateParents,
        $cartTaxRateEl,
        $savingsLine,
        $prepaymentAmt,
        $prepaymentLine,
        $prepaymentDeposits,
        $promoName,
        $promoEl,
        $collapseLink,
        $promoInput,
        $promoPreview,
        $promoApplyBtn,
        $cartItemPreview,
        $shippingPreview,
        $shippingPreviewAddress,
        $shippingPreviewPhone,
        $shippingPreviewEmail,
        $internationalShippingWarning,
        $intlDutiesNotice,
        $shippingBody,
        $shippingBodyToggle,
        $shippingOptionsParent,
        $shippingButtonsParent,
        $taxPreview,
        $taxPreviewTemplate,
        $taxStateWarning,
        $taxBody,
        $taxBodyToggle,
        $taxToggleYes,
        $taxToggleNo,
        $taxDetailsParent,
        $taxConfirmNone,
        $paymentBodyForm,
        $paymentBodyFieldSet,
        $paymentBody,
        $paymentBodyToggle,
        $paymentPreview,
        $paymentPreviewTemplate,
        $paymentPreviewItemCC,
        $paymentPreviewItemBank,
        $paymentPreviewItemOther,
        $additionalBody,
        $additionalBodyToggle,
        $additionalPreview,
        $additionalDetailsForm,
        $eventDateYes,
        $eventDateNo,
        $eventDate,
        $promoApproval,
        $smsApproval,
        $designApproval,
        $authorizePaymentBtn,
        $authorizePaymentText,
        $authorizePaymentTextPlaceOrder,
        $authorizePaymentTextPayPal,
        $gsaSmartPayWarning,
        $gsaSmartPayTaxAmount,
        $gsaSmartPayAddExemption,
    };
}
